import { type InfiniteData } from '@tanstack/react-query';
import { type z } from 'zod';

import { cursorPageSchema } from '@fiscoai/contracts';

/** Schema de página `{ items, nextCursor }` para um item do contrato. */
export function pagina<T extends z.ZodType>(item: T) {
  return cursorPageSchema(item);
}

/** Opções comuns de `useInfiniteQuery` com paginação por cursor. */
export const porCursor = {
  initialPageParam: undefined as string | undefined,
  getNextPageParam: (ultima: { nextCursor: string | null }) => ultima.nextCursor ?? undefined,
};

/** Junta as páginas carregadas numa lista só. */
export function juntarPaginas<T>(dados: InfiniteData<{ items: T[] }> | undefined): T[] {
  return dados?.pages.flatMap((p) => p.items) ?? [];
}
